var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadMoreAttachIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27393_23742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.07031 7.93148C6.33091 8.27987 6.66338 8.56814 7.04519 8.77674C7.42699 8.98533 7.84918 9.10938 8.28314 9.14046C8.7171 9.17153 9.15266 9.10892 9.5603 8.95686C9.96793 8.80481 10.3381 8.56686 10.6457 8.25916L12.4661 6.43873C13.0188 5.8665 13.3246 5.10009 13.3177 4.30457C13.3108 3.50905 12.9917 2.74807 12.4291 2.18553C11.8666 1.62299 11.1056 1.3039 10.3101 1.29699C9.51459 1.29008 8.74818 1.59589 8.17595 2.14857L7.13223 3.18622",
    stroke: "#598988",
    strokeWidth: 1.51703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49749 6.71672C8.23689 6.36833 7.90442 6.08007 7.52262 5.87147C7.14081 5.66287 6.71862 5.53883 6.28466 5.50775C5.8507 5.47667 5.41514 5.53929 5.00751 5.69134C4.59988 5.8434 4.22971 6.08135 3.92213 6.38904L2.1017 8.20948C1.54902 8.78171 1.2432 9.54812 1.25011 10.3436C1.25703 11.1392 1.57612 11.9001 2.13866 12.4627C2.70119 13.0252 3.46217 13.3443 4.25769 13.3512C5.05321 13.3581 5.81962 13.0523 6.39185 12.4996L7.4295 11.462",
    stroke: "#598988",
    strokeWidth: 1.51703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27393_23742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5635,
    height: 14.5635,
    fill: "white",
    transform: "translate(0.00390625 0.0390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadMoreAttachIcon);
export default __webpack_public_path__ + "static/media/ReadMoreAttachIcon.974fabb5603c0673fcaf6112312afd41.svg";
export { ForwardRef as ReactComponent };